import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {HOTB} from "../HOTB";

export class TopReelGlassOverlay extends PIXI.Container implements StageLayer {
    private _glassOverlay: PIXI.Sprite;

    constructor() {
        super();
        this.name = "TopReelGlassOverlay";
        this.init();
    }

    public toggleVisibility(show: boolean): void {
        this._glassOverlay.visible = show;
    }

    private init(): void {
        this.createGlassOverlay();
    }

    private createGlassOverlay(): void {
        this._glassOverlay = new PIXI.Sprite(HOTB.assetLoader.getTextures("topReelGlassOverlay")[0]);
        this._glassOverlay.position.set(360, 174.6);
        this._glassOverlay.anchor.set(0.5, 0.5);
        this.addChild(this._glassOverlay);
    }
}